export const translation = {
  nav: {
    home: 'Startseite',
    categories: 'Kategorien',
    spreadsheet: 'Tabelle',
    review: 'Bewertung',
    shipping: 'Versand',
    coupon: 'Gutschein',
    warehouse: 'Lager',
    legit: 'Ist es Legitim?',
    guide: 'Guides',
    blog: 'Blog',
    about: 'Über uns',
    contact: 'Kontakt',
    language: 'Sprache',
  },
  hero: {
    eyebrow: 'ALLCHINABUY TABELLE RESSOURCEN-HUB',
    h1: 'AllChinaBuy Tabelle — Produkte, Verkäufer & Kaufguides Finden',
    description: 'Entdecken Sie nützliche AllChinaBuy Tabellen-Ressourcen, Produktfunde, Verkäuferinformationen, QC-Guides, Versandtipps, Bewertungen und Kaufressourcen — organisiert in einem leicht durchsuchbaren Hub.',
    ctaPrimary: 'AllChinaBuy Tabelle Erkunden',
    ctaSecondary: 'Produktkategorien Durchsuchen',
    trustLine: 'Unabhängige Ressource • Aktualisierte Guides • Mehrsprachig • Forschungsorientiert',
  },
  search: {
    h2: 'Eine AllChinaBuy Tabelle-Ressource Finden',
    placeholder: 'Suche nach Produkten, Verkäufern, Tabellen, QC, Versand oder Guides...',
    button: 'Ressourcen Suchen',
    popular: 'Beliebt:',
    tags: 'Tabelle • Schuhe • Kleidung • QC • Versand • Bewertung • Gutschein',
  },
  categories: {
    h2: 'Beliebte AllChinaBuy Tabelle Kategorien',
    subtitle: 'Erkunden Sie Produktkategorien und finden Sie, was Sie über die AllChinaBuy Tabelle benötigen.',
    shoes: 'Schuhe',
    hoodies: 'Hoodies/Pullover',
    tshirts: 'T-Shirts',
    jackets: 'Jacken',
    pants: 'Hosen/Shorts',
    headwear: 'Kopfbedeckungen',
    sets: 'Sets',
    underwear: 'Unterwäsche/Slips',
    jersey: 'Trikots',
    accessories: 'Accessoires',
    bags: 'Taschen',
    belts: 'Gürtel',
    perfumes: 'Parfüms',
    other: 'Sonstiges',
    viewAll: 'Alle Kategorien Anzeigen',
  },
  value: {
    h2: 'Alles, Was Sie Brauchen, um AllChinaBuy an Einem Ort zu Recherchieren',
    description: 'Die Suche nach verstreuten Produktlinks, Verkäuferlisten und Kaufguides kann zeitaufwändig sein. Unser Ziel ist es, nützliche AllChinaBuy-Informationen in klare Kategorien zu organisieren, damit Sie Produkte recherchieren, QC verstehen, Versandoptionen vergleichen und fundiertere Kaufentscheidungen treffen können.',
    cards: {
      spreadsheet: { title: 'Tabellen-Ressourcen', desc: 'Erkunden Sie organisierte Tabellen-Ressourcen und Produktentdeckungs-Guides.' },
      seller: { title: 'Verkäufer-Recherche', desc: 'Lernen Sie, wie Sie Verkäuferinformationen und Produktlisten bewerten.' },
      qc: { title: 'QC-Guides', desc: 'Verstehen Sie QC-Fotos, Qualitätsfaktoren und häufige Probleme.' },
      shipping: { title: 'Versand-Guides', desc: 'Lernen Sie Versandmethoden, Kosten und Lieferfaktoren kennen.' },
      reviews: { title: 'Bewertungen & Vergleiche', desc: 'Vergleichen Sie wichtige Faktoren, bevor Sie eine Entscheidung treffen.' },
      safety: { title: 'Sicherheitszentrum', desc: 'Verstehen Sie Kauf-, Zahlungs-, Verkäufer- und Versandrisiken.' },
    },
  },
  review: {
    h2: 'AllChinaBuy Bewertung',
    description: 'Suchen Sie einen unabhängigen Überblick? Erkunden Sie unsere AllChinaBuy-Bewertung, die Einkauf, Versand, Lagerprozesse, Verkäuferrecherche und häufige Risiken abdeckt.',
    cta: 'Die AllChinaBuy-Bewertung Lesen',
  },
  shipping: {
    h2: 'AllChinaBuy Versandkosten & Versand-Guide',
    description: 'Der Versand kann je nach Zielort, Paketgröße, Gewicht, Versandmethode und Spediteurbedingungen variieren. Erfahren Sie, welche Faktoren die AllChinaBuy-Versandkosten und Lieferzeiten beeinflussen können.',
    cta: 'Versand-Guide Anzeigen',
  },
  coupon: {
    h2: 'AllChinaBuy Gutschein & Rabattcode',
    description: 'Suchen Sie nach aktuellen AllChinaBuy-Gutscheinen oder Rabattcodes? Überprüfen Sie unsere neueste Ressourcenseite und unterscheiden Sie klar zwischen verifizierten, unverifizierten und abgelaufenen Angeboten.',
    cta: 'Aktuelle Angebote Überprüfen',
  },
  warehouse: {
    h2: 'AllChinaBuy Lager-Guide',
    description: 'Erfahren Sie, wie Lagerung, QC, Paketkonsolidierung und Versandvorbereitung den Kaufprozess beeinflussen können.',
    cta: 'Lager-Guide Erkunden',
  },
  legit: {
    h2: 'Ist AllChinaBuy Legitim?',
    description: 'Bevor Sie eine Einkaufs- oder Kaufagentur-Plattform nutzen, verstehen Sie Verkäuferrisiken, Zahlungsüberlegungen, Produktqualität, Versand und Streitverfahren.',
    cta: 'Sicherheits- & Legitimitäts-Guide Lesen',
  },
  finalCta: {
    h2: 'Bereit, die AllChinaBuy Tabelle zu Erkunden?',
    description: 'Beginnen Sie mit der Tabelle, erkunden Sie Produktkategorien, lesen Sie die neuesten Guides und lernen Sie, wie Sie Produkte, Verkäufer, QC und Versand effektiver recherchieren.',
    ctaPrimary: 'AllChinaBuy Tabelle Erkunden',
    ctaSecondary: 'Kaufguides Lesen',
  },
  mainSite: {
    title: 'AllChinaBuy Tabelle',
    button: 'Jetzt Kaufen',
    description: 'Erkunden Sie die vollständige AllChinaBuy Tabelle auf unserer Hauptwebsite für den vollständigen Produktkatalog.',
  },
  footer: {
    tagline: 'Unabhängiger AllChinaBuy Tabelle Ressourcen-Hub',
    resources: 'Ressourcen',
    spreadsheet: 'Tabelle',
    categories: 'Kategorien',
    review: 'Bewertung',
    shipping: 'Versand',
    coupon: 'Gutschein',
    warehouse: 'Lager',
    legit: 'Ist es Legitim?',
    guides: 'Guides',
    company: 'Unternehmen',
    about: 'Über uns',
    contact: 'Kontakt',
    privacy: 'Datenschutzrichtlinie',
    terms: 'Nutzungsbedingungen',
    disclaimer: 'Haftungsausschluss',
    editorial: 'Redaktionelle Richtlinie',
    rights: 'Alle Rechte vorbehalten.',
    disclaimerText: 'Diese Website bietet allgemeine Bildungsinformationen. Sie garantiert keine Verkäuferqualität, Produktauthentizität, Versandergebnisse, Rückerstattungen oder Transaktionsergebnisse.',
  },
  languages: {
    en: 'English',
    fr: 'Français',
    de: 'Deutsch',
    da: 'Dansk',
  },
  common: {
    readMore: 'Weiterlesen',
    learnMore: 'Mehr Erfahren',
    explore: 'Erkunden',
    backToHome: 'Zurück zur Startseite',
    notFound: 'Seite Nicht Gefunden',
    notFoundDesc: 'Die gesuchte Seite existiert nicht.',
  },
  meta: {
    siteName: 'AllChinaBuy Tabelle Hub',
    homeTitle: 'AllChinaBuy Tabelle 2026 — Produkte, Verkäufer & Kaufguides',
    homeDesc: 'Erkunden Sie die AllChinaBuy Tabelle für Produkte, Verkäuferressourcen, QC-Guides, Versandinformationen, Bewertungen, Gutscheine und praktische Kauftipps.',
  },
};